const Months = [
  { label: 'Jan - 01', value: '01' },
  { label: 'Feb - 02', value: '02' },
  { label: 'Mar - 03', value: '03' },
  { label: 'Apr - 04', value: '04' },
  { label: 'May - 05', value: '05' },
  { label: 'June - 06', value: '06' },
  { label: 'July - 07', value: '07' },
  { label: 'Aug - 08', value: '08' },
  { label: 'Sept - 09', value: '09' },
  { label: 'Oct - 10', value: '10' },
  { label: 'Nov - 11', value: '11' },
  { label: 'Dec - 12', value: '12' },
];
const States = [
  { value: 'AL', label: 'AL' },
  { value: 'AK', label: 'AK' },
  { value: 'AZ', label: 'AZ' },
  { value: 'AR', label: 'AR' },
  { value: 'CA', label: 'CA' },
  { value: 'CO', label: 'CO' },
  { value: 'CT', label: 'CT' },
  { value: 'DE', label: 'DE' },
  { value: 'DC', label: 'DC' },
  { value: 'FL', label: 'FL' },
  { value: 'GA', label: 'GA' },
  { value: 'HI', label: 'HI' },
  { value: 'ID', label: 'ID' },
  { value: 'IL', label: 'IL' },
  { value: 'IN', label: 'IN' },
  { value: 'IA', label: 'IA' },
  { value: 'KS', label: 'KS' },
  { value: 'KY', label: 'KY' },
  { value: 'LA', label: 'LA' },
  { value: 'ME', label: 'ME' },
  { value: 'MD', label: 'MD' },
  { value: 'MA', label: 'MA' },
  { value: 'MI', label: 'MI' },
  { value: 'MN', label: 'MN' },
  { value: 'MS', label: 'MS' },
  { value: 'MO', label: 'MO' },
  { value: 'MT', label: 'MT' },
  { value: 'NC', label: 'NC' },
  { value: 'ND', label: 'ND' },
  { value: 'NE', label: 'NE' },
  { value: 'NV', label: 'NV' },
  { value: 'NH', label: 'NH' },
  { value: 'NJ', label: 'NJ' },
  { value: 'NM', label: 'NM' },
  { value: 'NY', label: 'NY' },
  { value: 'OH', label: 'OH' },
  { value: 'OK', label: 'OK' },
  { value: 'OR', label: 'OR' },
  { value: 'PA', label: 'PA' },
  { value: 'RI', label: 'RI' },
  { value: 'SC', label: 'SC' },
  { value: 'SD', label: 'SD' },
  { value: 'TN', label: 'TN' },
  { value: 'TX', label: 'TX' },
  { value: 'UT', label: 'UT' },
  { value: 'VT', label: 'VT' },
  { value: 'VA', label: 'VA' },
  { value: 'WA', label: 'WA' },
  { value: 'WV', label: 'WV' },
  { value: 'WI', label: 'WI' },
  { value: 'WY', label: 'WY' },
];

const Countries = [
  { value: 'BE', label: 'Belgium' },
  { value: 'CA', label: 'Canada' },
  { value: 'DE', label: 'Germany' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IT', label: 'Italy' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'ES', label: 'Spain' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
];

const getYears = () => {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  for (let index = 0; index < 201; index++) {
    years.push(currentYear + index);
  }
  return years.map((year) => {
    return { label: String(year), value: String(year) };
  });
};

const Years = getYears();

const Time = [
  { label: '12:00 AM', value: '00:00:00' },
  { label: '1:00 AM', value: '01:00:00' },
  { label: '2:00 AM', value: '02:00:00' },
  { label: '3:00 AM', value: '03:00:00' },
  { label: '4:00 AM', value: '04:00:00' },
  { label: '5:00 AM', value: '05:00:00' },
  { label: '6:00 AM', value: '06:00:00' },
  { label: '7:00 AM', value: '07:00:00' },
  { label: '8:00 AM', value: '08:00:00' },
  { label: '9:00 AM', value: '09:00:00' },
  { label: '10:00 AM', value: '10:00:00' },
  { label: '11:00 AM', value: '11:00:00' },
  { label: '12:00 PM', value: '12:00:00' },
  { label: '1:00 PM', value: '13:00:00' },
  { label: '2:00 PM', value: '14:00:00' },
  { label: '3:00 PM', value: '15:00:00' },
  { label: '4:00 PM', value: '16:00:00' },
  { label: '5:00 PM', value: '17:00:00' },
  { label: '6:00 PM', value: '18:00:00' },
  { label: '7:00 PM', value: '19:00:00' },
  { label: '8:00 PM', value: '20:00:00' },
  { label: '9:00 PM', value: '21:00:00' },
  { label: '10:00 PM', value: '22:00:00' },
  { label: '11:00 PM', value: '23:00:00' },
];

const TimeZones = [
  { label: '(GMT -12:00) Eniwetok, Kwajalein', value: '-12:00' },
  { label: '(GMT -11:00) Midway Island, Samoa', value: '-11:00' },
  { label: '(GMT -10:00) Hawaii', value: '-10:00' },
  { label: '(GMT -9:30) Taiohae', value: '-09:50' },
  { label: '(GMT -9:00) Alaska', value: '-09:00' },
  { label: '(GMT -8:00) Pacific Time (US & Canada)', value: '-08:00' },
  { label: '(GMT -7:00) Mountain Time (US & Canada)', value: '-07:00' },
  { label: '(GMT -6:00) Central Time (US & Canada)', value: '-06:00' },
  { label: '(GMT -5:00) Eastern Time (US & Canada), Raleigh', value: '-05:00' },
  { label: '(GMT -4:30) Caracas', value: '-04:50' },
  { label: '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz', value: '-04:00' },
  { label: '(GMT -3:30) Newfoundland', value: '-03:50' },
  { label: '(GMT -3:00) Brazil, Buenos Aires, Georgetown', value: '-03:00' },
  { label: '(GMT -2:00) Mid-Atlantic', value: '-02:00' },
  { label: '(GMT -1:00) Azores, Cape Verde Islands', value: '-01:00' },
  { label: '(GMT) Western Europe Time, London, Lisbon, Casablanca', value: '+00:00' },
  { label: '(GMT +1:00) Brussels, Copenhagen, Madrid, Paris', value: '+01:00' },
  { label: '(GMT +2:00) Kaliningrad, South Africa', value: '+02:00' },
  { label: '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg', value: '+03:00' },
  { label: '(GMT +3:30) Tehran', value: '+03:50' },
  { label: '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi', value: '+04:00' },
  { label: '(GMT +4:30) Kabul', value: '+04:50' },
  { label: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent', value: '+05:00' },
  { label: '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi', value: '+05:50' },
  { label: '(GMT +5:45) Kathmandu, Pokhara', value: '+05:75' },
  { label: '(GMT +6:00) Almaty, Dhaka, Colombo', value: '+06:00' },
  { label: '(GMT +6:30) Yangon, Mandalay', value: '+06:50' },
  { label: '(GMT +7:00) Bangkok, Hanoi, Jakarta', value: '+07:00' },
  { label: '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong', value: '+08:00' },
  { label: '(GMT +8:45) Eucla', value: '+08:75' },
  { label: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk', value: '+09:00' },
  { label: '(GMT +9:30) Adelaide, Darwin', value: '+09:50' },
  { label: '(GMT +10:00) Eastern Australia, Guam, Vladivostok', value: '+10:00' },
  { label: '(GMT +10:30) Lord Howe Island', value: '+10:50' },
  { label: '(GMT +11:00) Magadan, Solomon Islands, New Caledonia', value: '+11:00' },
  { label: '(GMT +11:30) Norfolk Island', value: '+11:50' },
  { label: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka', value: '+12:00' },
  { label: '(GMT +12:45) Chatham Islands', value: '+12:75' },
  { label: '(GMT +13:00) Apia, Nukualofa', value: '+13:00' },
  { label: '(GMT +14:00) Line Islands, Tokelau', value: '+14:00' },
];

const paginationOptions = [
  { value: '15', label: '15 per page' },
  { value: '25', label: '25 per page' },
  { value: '50', label: '50 per page' },
  { value: '100', label: '100 per page' },
];

export { Time, paginationOptions, TimeZones, Years, Countries, States, Months };
